var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cms-container" }, [
    _c(
      "ul",
      { staticClass: "size-18 ul-disc" },
      _vm._l(_vm.dataList, function (item, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass:
              "right-li li-before li-line-height font-18 flex align-center justify-between",
            on: {
              click: function ($event) {
                return _vm.toDetails(item)
              },
            },
          },
          [
            _c("div", { staticClass: "flex-1 text-omit-1 text-width" }, [
              _vm._v(_vm._s(item.name) + " "),
            ]),
            _c("div", { staticClass: "font-14" }, [
              _vm._v(_vm._s(_vm._f("fmDate")(item.createTime))),
            ]),
          ]
        )
      }),
      0
    ),
    _c(
      "div",
      {
        staticClass: "more-btn text-center font-18",
        on: { click: _vm.handleMore },
      },
      [_vm._v("查看更多")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }